export function trackPixel(event, params, eventId) {
  if (typeof window.fbq !== "function") return;
  window.fbq("track", event, params || {}, eventId ? { eventID: eventId } : undefined);
}

export const BOOKING_VALUE = { value: 200, currency: "MXN" };
